"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MR_OAUTH_AUTHENTICATE_TYPE = void 0;
const MR_OAUTH_AUTHENTICATE_TYPE = exports.MR_OAUTH_AUTHENTICATE_TYPE = 'mr_oauth/authenticate/status_changed';